module.exports = __webpack_public_path__ + "img/features.c342375b.png";